import type { QueryClient } from "@tanstack/react-query";
import { UNREACHABLE_MESSAGE } from "@/lib/api";
import { authClient } from "@/lib/auth-client";
import { clearAccountQueryData, sessionKey } from "./queries";

/**
 * Starts playing as a guest: a new guest session, then nothing cached from before, so every query
 * asks again as the guest. Whoever calls it goes on to where they were heading.
 */
export async function startGuestSession(queryClient: QueryClient): Promise<void> {
  const { error } = await authClient.signIn.anonymous();
  if (error) throw new Error(error.message?.trim() || UNREACHABLE_MESSAGE);
  clearAccountQueryData(queryClient);
  // Refetched rather than reset, so the signed-out answer stands until the guest's arrives and the
  // window goes straight from sign-in to the check, never through the shell.
  await queryClient.refetchQueries({ queryKey: sessionKey, exact: true });
}
